import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { useFormContext } from "react-hook-form";
import { useFeaturesEnabled, useBrand } from "@/contexts/cdpConfig/hooks";
import { useCustomFields, useImageHeaderSection } from "@/contexts/contact";
import { useContactingTestId } from "@/hooks";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { EmailInput } from "./EmailInput";
import { FirstLastNameInput } from "./FirstLastNameInput";
import { MessageInput } from "./MessageInput";
import { PhoneNumberInput } from "./PhoneNumberInput";
import { SalutationInput } from "./SalutationInput";
import { StreetInput } from "./StreetInput";
import { ZipCityInput } from "./ZipCityInput";
import { RequestCallbackImmonet, RequestCallbackImmowelt, RequestCallbackSeloger, RequestCallbackLogicImmo, } from "../../../UI";
import { useI18n } from "@/contexts/i18n";
export const ContactFormFields = ({ contactFormRootTestId, contactFormDatas, }) => {
    const { t } = useI18n();
    const testId = useContactingTestId(contactFormRootTestId);
    const { openedContactForm, extendedContactForm } = useFeaturesEnabled();
    const { locationEnabled } = useCustomFields();
    const showImageHeaderSection = useImageHeaderSection();
    const { control } = useFormContext();
    const showExtendedContactForm = locationEnabled && extendedContactForm;
    const gap = openedContactForm ? "spacing.16" : "spacing.24";
    const brand = useBrand();
    const getRequestCallbackImage = () => {
        switch (brand) {
            case "immowelt":
                return _jsx(RequestCallbackImmowelt, {});
            case "immonet":
                return _jsx(RequestCallbackImmonet, {});
            case "seloger":
                return _jsx(RequestCallbackSeloger, {});
            case "logicimmo":
                return _jsx(RequestCallbackLogicImmo, {});
            default:
                return _jsx(RequestCallbackImmowelt, {});
        }
    };
    return (_jsxs(_Fragment, { children: [showImageHeaderSection && (_jsxs(_Fragment, { children: [_jsx(Divider, { marginBottom: "spacing.24", "aria-hidden": "true" }), _jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", gap: "spacing.16", children: [getRequestCallbackImage(), _jsx(Box, { minHeight: "20px", verticalAlign: "middle", typography: "typography.headline.20.bold", textAlign: "center", children: t("contact.mobile_phones.callback_description") })] }), _jsx(Divider, { marginVertical: "spacing.24", "aria-hidden": "true" })] })), _jsxs(Box, { display: "flex", flexDirection: "column", gap: gap, children: [_jsx(SalutationInput, { control: control, testId: testId }), _jsx(FirstLastNameInput, { control: control, testId: testId }), _jsx(EmailInput, { control: control, testId: testId }), _jsx(PhoneNumberInput, { control: control, testId: testId }), showExtendedContactForm && (_jsxs(_Fragment, { children: [_jsx(StreetInput, { control: control, testId: testId }), _jsx(ZipCityInput, { control: control, testId: testId })] })), _jsx(MessageInput, { control: control, contactFormDatas: contactFormDatas, showMessageToggleCTA: openedContactForm })] })] }));
};
